import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useJetAssignmentsContextValue } from '../context/JetAssignmentsProvider'

export const JetAssignmentsHeader = () => {
  const { state, actions } = useJetAssignmentsContextValue()

  return (
    <Header
      title="Jet Assignments"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
